import { type CSSProperties, type ReactNode } from 'react';
import { type DefaultTheme, styled } from 'styled-components';

type ColumnProps = {
  space: keyof DefaultTheme['space']['component']['y'];
  justifyItems?: CSSProperties['justifyItems'];
  alignContent?: CSSProperties['alignContent'];
  children: ReactNode;
};

export const Column = styled.div<ColumnProps>`
  display: flex;
  flex-direction: column;
  justify-items: ${({ justifyItems = 'flex-start' }) => justifyItems};
  align-content: ${({ alignContent = 'flex-start' }) => alignContent};
  && > * {
    margin-bottom: ${({ space, theme }) => theme.space.component.y[space]};
  }
  && > *:last-child {
    margin-bottom: 0;
  }
`;
Column.displayName = 'Flex.Column';
